var _path, _rect, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C4.5 6.68629 7.18629 4 10.5 4H30.5C33.8137 4 36.5 6.68629 36.5 10V14H4.5V10Z",
    fill: "#FF9500"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 14,
    x2: 35.5,
    y2: 14,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4942 23.28L22.7742 19.38H20.6742L17.6142 24.855C17.3142 25.38 17.1042 26.07 17.1042 26.7C17.1042 28.665 18.6342 30.12 20.6142 30.12C22.6242 30.12 24.1242 28.65 24.1242 26.7C24.1242 24.66 22.6542 23.28 20.7342 23.28H20.4942ZM20.6142 25.02C21.5142 25.02 22.2342 25.62 22.2342 26.7C22.2342 27.72 21.5142 28.38 20.6142 28.38C19.7292 28.38 18.9942 27.72 18.9942 26.7C18.9942 25.62 19.7142 25.02 20.6142 25.02Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar6);
export default __webpack_public_path__ + "static/media/calendar-6.04e72b0b6d3197d0a51f3d321c2a0b1a.svg";
export { ForwardRef as ReactComponent };